import { useNavigate } from "react-router-dom";
import { LoopController } from "../LoopController/LoopController";

import "./LoopPage.css";
import { LoopTest } from "../LoopTest/LoopTest";

export function LoopPage(): JSX.Element {
    const navigate = useNavigate();
    const handleControllerClick = () => {
        navigate("/home/controller");
    }
    const handleTestClick = () => {
        navigate("/home/test")
    }
    return (
        <div className="LoopPage">
            <span className="loopControllerBtn" onClick={handleControllerClick}>LoopController</span>
            {/* <span className="loopTestBtn" onClick={handleTestClick}>TestController</span> */}
        </div>
    );
};
